import { render, staticRenderFns } from "./UcInflationIndexedPriceChangeNotificationCard.yaml?vue&type=template&id=4a8cd80a&component"
import script from "./UcInflationIndexedPriceChangeNotificationCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcInflationIndexedPriceChangeNotificationCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports